// ⚠️⚠️⚠️⚠️ DO NOT EDIT ⚠️⚠️⚠️⚠️
// This file was automatically generated, run yarn gen:gql to update it
/* eslint-disable */

import type * as Types from '../../../../schema/public';

import { gql } from '@apollo/client';
import { GameFragmentDoc } from '../../../shared/graphql/GameFragment.generated';
export type SingleGameFragment = { __typename?: 'CasinoGame', maxBet?: number, blocked?: boolean, blockedReason?: string, volatility?: number, payLines?: string, hitRatio?: number, bgColor?: string, bgImg?: string, id: string, name?: string, handle?: string, thumbUrl?: string, thumbUrlTab?: string, href?: string, isTrending?: boolean, isHot?: boolean, isNew?: boolean, isHighRoller?: boolean, isFavourite?: boolean, inLoyalty?: boolean, rtp?: number, rtpLivePastDay?: number, rtpLivePastSevenDays?: number, rtpLivePastThirtyDays?: number, isFeatured?: boolean, minBet?: number, hasFunMode?: boolean, category?: { __typename?: 'CasinoCategory', id: string, handle?: string }, menuItem?: Array<{ __typename?: 'CasinoGameMenuItem', id: string, handle?: string, name?: string, inGameCurrencies?: string }>, themes?: { __typename?: 'CasinoGameThemeConnection', edges?: Array<{ __typename?: 'CasinoGameThemeEdge', node?: { __typename?: 'CasinoGameTheme', id: string, name?: string, handle?: string } }> } };

export const SingleGameFragmentDoc = /*#__PURE__*/ gql`
    fragment SingleGameFragment on CasinoGame {
  ...GameFragment
  maxBet(currency: $currency)
  blocked
  blockedReason
  hasFunMode: hasDemoMode
  volatility
  payLines
  hitRatio
  bgColor
  bgImg
  category {
    id
    handle
  }
  menuItem(section: 1) {
    id
    handle
    name
    inGameCurrencies
  }
}
    ${GameFragmentDoc}`;